module.exports = __webpack_public_path__ + "media/images/kid/kid_avatar_03-16c9d1d24b35c801fbe4691c85e309d2.png";